export var TowVehicleMediaType;
(function (TowVehicleMediaType) {
    TowVehicleMediaType["ARRIVED"] = "arrived";
    TowVehicleMediaType["COMPLETED"] = "completed";
})(TowVehicleMediaType || (TowVehicleMediaType = {}));
